import { Box } from "@mui/material";

export const Spacer = () => {
    return <Box flexGrow={1} />;
};
